import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { ClassDetailsView, classQueryOptions } from '@/modules/classes'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/students-and-classes/classes/$classId/details'
)({
  component: ClassDetailsView,
  loader: async ({ context, params: { classId } }) => {
    const { displayName } = await context.queryClient.ensureQueryData(
      classQueryOptions(classId)
    )
    return displayName
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.details', { ns: 'classes' })
    ])
})
